'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';
import ProjectChronologyModalCreate from './controller/chronologyModalCreate';
import ProjectChronologyTableDirective from './directive/projectChronologyTable';

export default angular.module('investmentProject.project.chronology', [])
                      .controller('ProjectChronologyModalCreateController', ProjectChronologyModalCreate)
                      .directive('projectChronologyTable', ProjectChronologyTableDirective)
    .name;
